
<template>
  <div
    class="flip-carousel"
    :style="{ height: height + 'px' }"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="flip-container">
      <!-- 同时渲染所有项，通过 active 类控制透明度 -->
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flip-item"
        :class="{ active: index === currentIndex }"
      >
        <slot :item="item" :index="index"></slot>
      </div>
    </div>

    <button v-if="items.length > 1" class="arrow left" @click="prev" :disabled="animating">‹</button>
    <button v-if="items.length > 1" class="arrow right" @click="next" :disabled="animating">›</button>

    <div v-if="items.length > 1" class="indicators">
      <span
        v-for="(item, index) in items"
        :key="index"
        :class="['dot', { active: index === currentIndex }]"
        @click="goTo(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlipCarousel',
  props: {
    items: { type: Array, required: true },
    height: { type: Number, default: 300 },
    loop: { type: Boolean, default: true },
    duration: { type: Number, default: 2000 },
    autoplay: { type: Boolean, default: false },
    interval: { type: Number, default: 5000 },
    pauseOnHover: { type: Boolean, default: true },
    imageKey: { type: String, default: '' },
  },
  data() {
    return {
      currentIndex: 0,
      animating: false, // 防止动画期间重复点击
      autoplayTimer: null,
      isHovering: false,
      animatingTimer: null, // 用于重置 animating 的定时器
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(newVal) {
        if (this.currentIndex >= newVal.length) {
          this.currentIndex = newVal.length - 1;
        }
        if (this.currentIndex < 0) {
          this.currentIndex = 0;
        }
        if (newVal.length <= 1) {
          this.stopAutoplay();
        } else if (this.autoplay && !this.autoplayTimer) {
          this.startAutoplay();
        }
        this.preloadAllImages();
      },
    },
    autoplay(val) {
      if (val && this.items.length > 1) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    },
  },
  mounted() {
    if (this.autoplay && this.items.length > 1) {
      this.startAutoplay();
    }
    this.preloadAllImages();
  },
  beforeDestroy() {
    this.stopAutoplay();
    if (this.animatingTimer) clearTimeout(this.animatingTimer);
  },
  methods: {
    preloadAllImages() {
      this.items.forEach(item => {
        let url = '';
        if (typeof item === 'string') {
          url = item;
        } else if (item && typeof item === 'object' && this.imageKey && item[this.imageKey]) {
          url = item[this.imageKey];
        }
        if (url && typeof url === 'string') {
          const img = new Image();
          img.src = url;
        }
      });
    },

    // 设置动画状态，持续 duration 毫秒
    startAnimating() {
      this.animating = true;
      if (this.animatingTimer) clearTimeout(this.animatingTimer);
      this.animatingTimer = setTimeout(() => {
        this.animating = false;
        this.animatingTimer = null;
      }, this.duration);
    },

    prev() {
      if (this.animating) return;
      let newIndex;
      if (this.currentIndex > 0) {
        newIndex = this.currentIndex - 1;
      } else if (this.loop) {
        newIndex = this.items.length - 1;
      } else {
        return;
      }
      this.currentIndex = newIndex;
      this.startAnimating();
      this.restartAutoplay();
    },

    next() {
      if (this.animating) return;
      let newIndex;
      if (this.currentIndex < this.items.length - 1) {
        newIndex = this.currentIndex + 1;
      } else if (this.loop) {
        newIndex = 0;
      } else {
        return;
      }
      this.currentIndex = newIndex;
      this.startAnimating();
      this.restartAutoplay();
    },

    goTo(index) {
      if (this.animating || index === this.currentIndex) return;
      this.currentIndex = index;
      this.startAnimating();
      this.restartAutoplay();
    },

    startAutoplay() {
      if (
        !this.autoplay ||
        this.autoplayTimer ||
        this._isBeingDestroyed ||
        this._isDestroyed ||
        this.items.length <= 1
      ) {
        return;
      }
      this.animatingTimer = null;
      clearTimeout(this.autoplayTimer);

      const timer = setTimeout(() => {
        if (!this.autoplay) {
          this.stopAutoplay();
          return;
        }
        if (this.pauseOnHover && this.isHovering) {
          this.startAutoplay();
          return;
        }
        if (!this.animating) {
          this.next();
        }
        if (this.autoplay) {
          this.startAutoplay();
        }
      }, this.interval);
      this.autoplayTimer = timer;
    },

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    restartAutoplay() {
      if (!this.autoplay || this.items.length <= 1) return;
      this.stopAutoplay();
      this.startAutoplay();
    },

    onMouseEnter() {
      // this.isHovering = true;
      // if (this.pauseOnHover && this.autoplay) {
        // this.stopAutoplay();
      // }
    },

    onMouseLeave() {
      // this.isHovering = false;
      // if (this.pauseOnHover && this.autoplay && this.items.length > 1) {
        // this.startAutoplay();
      // }
    },
  },
};
</script>

<style scoped>
.flip-carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.flip-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.flip-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backface-visibility: hidden;
  opacity: 0;
  /* transition: opacity var(--duration) ease; */
  /* transition: opacity var(--duration) cubic-bezier(0.4, 0, 0.2, 1); */
  transition: opacity 2s cubic-bezier(0.32, 0.28, 0.58, 1);
  pointer-events: none; /* 非活动项不接收点击事件，避免干扰 */
}

.flip-item.active {
  opacity: 1;
  pointer-events: auto; /* 活动项可点击 */
}

/* 箭头和指示器样式保持不变 */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  /* background-color: rgba(0, 0, 0, 0.3); */
  background-color: rgba(255, 0, 0, 0.2);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 40px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}
.arrow:hover:not(:disabled) {
  /* background-color: rgba(0, 0, 0, 0.6); */
  background-color: rgba(255, 0, 0, 0.4);
}
.arrow:disabled {
  /* opacity: 0.3; */
  cursor: not-allowed;
}
.arrow.left { left: 50px; }
.arrow.right { right: 50px; }

.indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.3s;
}
.dot.active {
  background-color: white;
}
</style>